export const CASE_ID_REGEX = /^[A-Z0-9][A-Z0-9_-]{2,49}$/

export const API_BASE = import.meta.env.VITE_API_BASE_URL || ''

export const APP_NAME = import.meta.env.VITE_APP_NAME || '3D Model Viewer'
